<template>
  <div>
    <v-row>
    <v-col cols="6" sm="4" md="2">
      <v-card class="primary darken-1 quality">
        <v-row class="align-start justify-start ml-2 mr-2">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
          </v-col>
        </v-row>
        <v-card-title class="mt-n5">
          <v-icon color="secondary" class="mb-2">
            mdi-beer-outline
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold white--text">Qualidade da água</v-card-subtitle>
        <v-card-text>
          <v-row class="white--text">
            <v-col class="pa-3" cols="12">
              <h2>Em breve</h2>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6" sm="4" md="2">
      <v-card class="primary darken-1">
        <v-row class="align-start justify-start ml-2 mr-2" v-if="tendency">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em {{ yesterday }}</span>
          </v-col>
        </v-row>
        <v-row class="align-start justify-start ml-2 mr-2" v-else>
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
          </v-col>
        </v-row>
        <v-card-title class="mt-n5">
          <v-icon color="secondary" class="mb-2">
            mdi-arrow-expand-vertical
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold white--text">Tendência do reservatório</v-card-subtitle>
        <v-card-text>
          <v-row v-if="!tendency">
            <v-col cols="3">
              <v-icon color="orange" right>mdi-information-outline</v-icon>
            </v-col>
            <v-spacer/>
            <v-col cols="9">
              <span style="color: orange">Os dados de tendência do reservatório estão indisponíveis no momento.</span>
            </v-col>
          </v-row>
          <v-row v-else class="white--text">
            <v-col cols="12">
              <strong class="display-1 font-weight-bold">
                <span>{{ tendency }}</span>
              </strong>
            </v-col>
            <v-col cols="12">
              <span>Baseado nos dados dos dois últimos dias</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6" sm="4" md="2">
      <v-card class="primary darken-1">
        <v-row class="align-start justify-start ml-2 mr-2" v-if="affluentFlow">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em {{ affluentFlow.updated.split('T')[0] }} às {{ affluentFlow.updated.split('T')[1] }}</span>
          </v-col>
        </v-row>
        <v-card-title class="mt-n5">
          <v-icon color="secondary" class="mb-2">
            mdi-waves
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold white--text">Vazão afluente</v-card-subtitle>
        <v-card-text>
          <v-row v-if="!affluentFlow">
            <v-col cols="3">
              <v-icon color="orange" right>mdi-information-outline</v-icon>
            </v-col>
            <v-spacer/>
            <v-col cols="9">
              <span style="color: orange">Os dados de vazão afluente estão indisponíveis no momento.</span>
            </v-col>
          </v-row>
          <v-row v-else class="white--text">
            <v-col cols="12" sm="12" md="12" class="align-center justify-center">
              <strong class="display-1 font-weight-bold">{{ (affluentFlow.flow).toFixed(3) }} </strong>
              <strong>m³/s</strong>
            </v-col>
            <v-col cols="12">
              <span>Soma das vazões das bacias de contribuição</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6" sm="4" md="2">
      <v-card class="primary darken-1">
        <v-row class="align-start justify-start ml-2 mr-2">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
          </v-col>
        </v-row>
        <v-card-title class="mt-n5">
          <v-icon color="secondary" class="mb-2">
            mdi-waves
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold white--text">Vazão defluente</v-card-subtitle>
        <v-card-text>
          <v-row class="white--text">
            <v-col class="pa-3" cols="12">
              <h2>Em breve</h2>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
      <v-col class="hidden-sm-and-down" cols="12" sm="4" md="2">
        <v-card class="primary darken-1">
          <v-row class="align-start justify-start ml-2 mr-2" v-if="accumulatedOfLastThirtyDays">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span style="color: lightgrey; font-size: small">Atualizado em {{ accumulatedOfLastThirtyDays.updated }}</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2">
              mdi-weather-pouring
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">Chuva dos últimos 30 dias</v-card-subtitle>
          <v-card-text>
            <v-row v-if="accumulatedOfLastThirtyDays === undefined">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer/>
              <v-col cols="9">
                <span style="color: orange">Os dados de chuva dos últimos 30 dias estão indisponíveis no momento.</span>
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  <span v-if="accumulatedOfLastThirtyDays.value !== undefined"> {{ accumulatedOfLastThirtyDays.value.toFixed(1) }} </span>
                  <span v-else> {{ accumulatedOfLastThirtyDays.value }} </span>
                  <span class="font-weight-thin title">mm</span>
                </strong>
              </v-col>
              <v-col cols="12">
                <span>Acumulado dos últimos 30 dias</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="hidden-sm-and-down" cols="12" sm="4" md="2">
      <v-card class="primary darken-1">
        <v-row class="align-start justify-start ml-2 mr-2" v-if="!climatographicAverage">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
          </v-col>
        </v-row>
        <v-row v-else class="align-start justify-start ml-2 mr-2">
          <v-col cols="1">
            <v-icon style="color: lightgrey" left small>restore</v-icon>
          </v-col>
          <v-col cols="10">
            <span style="color: lightgrey; font-size: small">Atualizado em {{ climatographicAverage.updated }}</span>
          </v-col>
        </v-row>
        <v-card-title class="mt-n5">
          <v-icon color="secondary" class="mb-2">
            mdi-weather-pouring
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold white--text">Média climatológica</v-card-subtitle>
        <v-card-text>
          <v-row v-if="!climatographicAverage">
            <v-col cols="3">
              <v-icon color="orange" right>mdi-information-outline</v-icon>
            </v-col>
            <v-spacer/>
            <v-col cols="9">
              <span style="color: orange">Os dados de média climatológica estão indisponíveis no momento.</span>
            </v-col>
          </v-row>
          <v-row v-else class="white--text">
            <v-col cols="12">
              <strong class="display-1 font-weight-bold">
                {{ climatographicAverage.value.toFixed(1) }} <span class="font-weight-thin title mt-5">mm</span>
              </strong>
            </v-col>
            <v-col cols="12">
              <span>Média de 1979 - {{ climatographicAverage.year }} do mês de {{ climatographicAverage.month }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <sensor351-card
      v-if="showReservoirRuler && latestInfo"
      :sensorData="latestInfo"
      :rulerImageInfo="latestInfo"
      cardTitle="Última Leitura"
    />
    <sensor351-card
      v-if="showReservoirRuler && morningInfo"
      :sensorData="morningInfo"
      :rulerImageInfo="morningInfo"
      cardTitle="Manhã"
    />
    <sensor351-card
      v-if="showReservoirRuler && middayInfo"
      :sensorData="middayInfo"
      :rulerImageInfo="middayInfo"
      :cardTitle="'Meio do dia'"
    />
    <sensor351-card
      v-if="showReservoirRuler && afternoonInfo"
      :sensorData="afternoonInfo"
      :rulerImageInfo="afternoonInfo"
      :cardTitle="'Fim da tarde'"
    />
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import Sensor351Card from "./ReservoirRuler";
import { loadRulerImageInfo, getRulerImageUrl } from "@/api/riak/ruler-image.api";
import { loadReadingsData } from "@/api/telemetry/readings-data.api";

export default {
  props: ['affluentFlow', 'tendency', 'accumulatedOfLastThirtyDays', 'climatographicAverage', 'sensorData', 'rulerImageInfo', 'showReservoirRuler'],
  name: "HydrologicalDataCards",
  components: { Sensor351Card },
  data(){
    return{
      yesterday: moment().subtract(1, 'days').format('DD/MM/YYYY'),
      latestInfo: null,
      morningInfo: null,
      middayInfo: null,
      afternoonInfo: null,
      loading: true
    }
  },

  async mounted() {
    await this.fetchAllRulerData();
  },

  methods: {
    async fetchAllRulerData() {
      try {
        this.loading = true;

        const datetime_start = moment().subtract(1, 'days').utc().format();
        const datetime_end = moment().utc().format();

        const responseSensor = await loadReadingsData({
          station_ids: "25484909",
          sensor_ids: "351",
          datetime_start,
          datetime_end
        });

        const sensorList = responseSensor.data || responseSensor;

        const [latest, morning, midday, afternoon] = await Promise.all([
          this.safeLoad('latest'),
          this.safeLoad('manha'),
          this.safeLoad('meio_do_dia'),
          this.safeLoad('fim_da_tarde')
        ]);

        this.latestInfo = this.mergeData(latest, sensorList[0]);

        const readingManha = this.findReadingByHour(sensorList, 9);
        this.morningInfo = this.mergeData(morning, readingManha);

        const readingMeioDia = this.findReadingByHour(sensorList, 12);
        this.middayInfo = this.mergeData(midday, readingMeioDia);

        const readingFimTarde = this.findReadingByHour(sensorList, 17);
        this.afternoonInfo = this.mergeData(afternoon, readingFimTarde);


      } catch (error) {
        console.error("Erro ao carregar réguas:", error);
      } finally {
        this.loading = false;
      }
    },

    findReadingByHour(list, targetHour) {
      if (!list || !Array.isArray(list)) return null;

      return list.find(item => {
        const hour = moment(item.datahora).hours();
        return hour === targetHour;
      });
    },

    mergeData(riakData, sensorData) {
      if (!riakData && !sensorData) return null;

      return {
        ...riakData,

        leitura: sensorData ? sensorData.leitura : (riakData ? riakData.value : '---'),
        datahora: sensorData ? sensorData.datahora : (riakData ? riakData.measurement_date : null),

        qualidadeId: sensorData ? sensorData.qualidadeId : null
      };
    },

    async safeLoad(period) {
      const jsonData = await loadRulerImageInfo(period);

      if (!jsonData) return null;

      const imageUrl = getRulerImageUrl(period);

      return {
        ...jsonData,
        imageUrl: imageUrl,
        periodLabel: period
      };
    }
  },
}
</script>

<style scoped>
.quality.v-card.v-sheet.theme--dark {
  border-left: 7px solid white !important;
}
.v-card.v-sheet.theme--dark {
  min-height: 306px;
  min-width: 150px;
  height: 100%;
  max-width: 350px;
}
</style>
